import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListStartedAtCell } from '@app/feature/transaction/transaction-list/transaction-list-started-at.cell';
import { TransactionListStartedAtHeader } from '@app/feature/transaction/transaction-list/transaction-list-started-at.header';

export const TokenTransactionListStartedAtColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['startedAt']
> = {
  enableSorting: true,
  header: TransactionListStartedAtHeader,
  cell: TransactionListStartedAtCell,
};
